var _a;
import { LogLevel, ServerZone, } from '@amplitude/analytics-types';
import { AMPLITUDE_SERVER_URL, AMPLITUDE_BATCH_SERVER_URL, EU_AMPLITUDE_SERVER_URL, EU_AMPLITUDE_BATCH_SERVER_URL, } from './constants';
import { Logger } from './logger';
var DEFAULT_INSTANCE = 'default';
var instances = {};
export var serverUrls = (_a = {},
    _a[ServerZone.US] = function (useBatch) { return (useBatch ? AMPLITUDE_BATCH_SERVER_URL : AMPLITUDE_SERVER_URL); },
    _a[ServerZone.EU] = function (useBatch) { return (useBatch ? EU_AMPLITUDE_BATCH_SERVER_URL : EU_AMPLITUDE_SERVER_URL); },
    _a);
export var defaultConfig = {
    flushMaxRetries: 5,
    flushQueueSize: 10,
    flushIntervalMillis: 1000,
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    saveEvents: true,
    optOut: false,
    serverUrl: AMPLITUDE_SERVER_URL,
    serverZone: ServerZone.US,
    useBatch: false,
};
var Config = /** @class */ (function () {
    function Config(options) {
        var _a, _b, _c, _d;
        this.apiKey = options.apiKey;
        this.userId = options.userId;
        this.deviceId = options.deviceId;
        this.sessionId = options.sessionId;
        this.flushIntervalMillis = options.flushIntervalMillis || defaultConfig.flushIntervalMillis;
        this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
        this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
        this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
        this.logLevel = (_a = options.logLevel) !== null && _a !== void 0 ? _a : defaultConfig.logLevel;
        this.partnerId = options.partnerId;
        this.plugins = [];
        this.optOut = (_b = options.optOut) !== null && _b !== void 0 ? _b : defaultConfig.optOut;
        this.saveEvents = (_c = options.saveEvents) !== null && _c !== void 0 ? _c : defaultConfig.saveEvents;
        this.serverUrl = options.serverUrl;
        this.serverZone = options.serverZone || defaultConfig.serverZone;
        this.storageProvider = options.storageProvider;
        this.transportProvider = options.transportProvider;
        this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
        this.loggerProvider.enable(this.logLevel);
        configApiHost(this);
    }
    return Config;
}());
export { Config };
export var createConfig = function (config) {
    // If config for an instance already exists, perform Object.assign() to reuse reference
    // to config object. This is useful when config object reference is used in plugins
    instances[DEFAULT_INSTANCE] = instances[DEFAULT_INSTANCE]
        ? Object.assign(instances[DEFAULT_INSTANCE], config)
        : config;
    return instances[DEFAULT_INSTANCE];
};
export var getConfig = function () {
    return instances[DEFAULT_INSTANCE];
};
export var resetInstances = function () {
    for (var name in instances) {
        delete instances[name];
    }
};
export var getApiHost = function (config) {
    return configApiHost(config);
};
var configApiHost = function (config) {
    if (!config.serverUrl) {
        // Log a warning if server zone is neither US nor EU
        if (![ServerZone.US, ServerZone.EU].includes(config.serverZone)) {
            config.loggerProvider.warn("Unknown server zone \"".concat(config.serverZone, "\". Replaced with US server zone"));
            config.serverZone = ServerZone.US;
        }
        config.serverUrl = serverUrls[config.serverZone](config.useBatch);
    }
    return config.serverUrl;
};
//# sourceMappingURL=config.js.map